module.exports = __webpack_public_path__ + "img/icone_aceito.68e71154.svg";